import { createGlobalStyle } from 'styled-components';

const Typography = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap');
  html {
    font-size: ${({ theme }) => theme.typography.htmlFontSize}px;
  }
  body {
    color: ${({ theme }) => theme.palette.text.main};
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  .no_margin_top{
    margin-top: 0;
  }

  h1 {
    font-family: ${({ theme }) => theme.typography.h1.fontFamily};
    font-weight: ${({ theme }) => theme.typography.h1.fontWeight};
    font-size: ${({ theme }) => theme.typography.h1.fontSize};
    margin: ${({ theme }) => theme.spacing * 2}px 0;
  }

  h2 {
    font-family: ${({ theme }) => theme.typography.h2.fontFamily};
    font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
    font-size: ${({ theme }) => theme.typography.h2.fontSize};
  }

  h3 {
    font-family: ${({ theme }) => theme.typography.h3.fontFamily};
    font-weight: ${({ theme }) => theme.typography.h3.fontWeight};
    font-size: ${({ theme }) => theme.typography.h3.fontSize};
  }

  h4 {
    margin: 0 0 ${({ theme }) => theme.spacing * 1.5}px 0;
    color: ${({ theme }) => theme.palette.card.title};
    font-weight: 600;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  small {
    font-size: ${({ theme }) => theme.typography.small.fontSize};
  }


  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 100;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Thin.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Thin.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Thin.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Thin.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Thin.svg#SohoGothicW01Thin") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 100;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ThinItali.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ThinItali.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ThinItali.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ThinItali.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ThinItali.svg#SohoGothicW01ThinItalic") format("svg")
  }

  @font-face {
    font-family:"Soho Gothic W01";
    font-weight: 300;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Light.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Light.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Light.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Light.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Light.svg#SohoGothicW01Light") format("svg");
  }

  @font-face {
    font-family:"Soho Gothic W01";
    font-weight: 300;
    font-style: italic;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-LightItal.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-LightItal.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-LightItal.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-LightItal.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-LightItal.svg#SohoGothicW01LightItalic") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 400;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Regular.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Regular.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Regular.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Regular.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Regular.svg#SohoGothicW01Regular") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 400;
    font-style: italic;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Italic.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Italic.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Italic.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Italic.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Italic.svg#SohoGothicW01Italic") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 600;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Medium.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Medium.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Medium.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Medium.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Medium.svg#SohoGothicW01Medium") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 700;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Bold.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Bold.eot?#iefix") format("eot"),
      url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Bold.woff") format("woff"),
      url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Bold.ttf") format("truetype"),
      url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01Bold.svg#SohoGothicW01Bold") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 700;
    font-style: italic;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-BoldItali.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-BoldItali.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-BoldItali.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-BoldItali.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-BoldItali.svg#SohoGothicW01BoldItalic") format("svg")
  }

  @font-face{
    font-family:"Soho Gothic W01";
    font-weight: 800;
    font-style: normal;
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ExtraBold734925.eot?#iefix");
    src:url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ExtraBold734925.eot?#iefix") format("eot"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ExtraBold734925.woff") format("woff"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ExtraBold734925.ttf") format("truetype"),
        url("https://dqqzjdqmiszdy.cloudfront.net/sites/all/themes/specsavers_bootstrap/fonts/SohoGothicW01-ExtraBold734925.svg#SohoGothicW01ExtraBold") format("svg")
  }

`;

export default Typography;
